const ActionCategoryThemes = {
  QUICK_ACTIONS: {
    icon: 'workflows',
    theme: 'koala'
  },
  AI_SKILLS: {
    icon: 'breezeSingleStar',
    theme: 'breeze'
  },
  COMMUNICATIONS: {
    icon: 'email',
    theme: 'thunderdome'
  },
  CRM: {
    icon: 'lists',
    theme: 'oz'
  },
  MARKETING: {
    icon: 'campaigns',
    theme: 'sorbet'
  },
  DATA_OPS: {
    icon: 'serverlessFunction',
    theme: 'marigold'
  },
  UNCATEGORIZED: {
    icon: 'integrations',
    theme: 'battleship'
  }
};
export default ActionCategoryThemes;